// Code generated by protoc-gen-ts_proto_ipc_plugin. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto_internal_plugin  v0.1.20
//   protoc               v6.30.2
// source: services/transportation/reports/oil.proto

/* eslint-disable */
import { Injectable } from "@angular/core";
import { GrpcWebErrrHandlingImpl } from "src/app/shared/services/grpc-client";
import { EmptyRequest } from "../../../common/messages/messages";
import {
  GetOilDeliveryNoteRequest,
  GetOilDeliveryNotesRequest,
  GetOilDeliveryNotesResponse,
  OilDeliveryNote,
  OilDeliveryNoteResponse,
  UpdateOilDeliveryNoteRequest,
} from "./oil";

import { OilServiceClientImpl } from "./oil";

@Injectable({ providedIn: "root" })
export class OilServiceSpa {
  constructor(private _rpc: GrpcWebErrrHandlingImpl) {}
  async getOneOilDeliveryNote(request: GetOilDeliveryNoteRequest): Promise<OilDeliveryNoteResponse> {
    const client = new OilServiceClientImpl(this._rpc);
    return await client.getOneOilDeliveryNote(request);
  }
  async addOilDeliveryNote(request: OilDeliveryNote): Promise<OilDeliveryNoteResponse> {
    const client = new OilServiceClientImpl(this._rpc);
    return await client.addOilDeliveryNote(request);
  }
  async updateOilDeliveryNote(request: UpdateOilDeliveryNoteRequest): Promise<OilDeliveryNoteResponse> {
    const client = new OilServiceClientImpl(this._rpc);
    return await client.updateOilDeliveryNote(request);
  }
  async getAllOilDeliveryNotes(request: EmptyRequest): Promise<GetOilDeliveryNotesResponse> {
    const client = new OilServiceClientImpl(this._rpc);
    return await client.getAllOilDeliveryNotes(request);
  }
  async getOilDeliveryNotes(request: GetOilDeliveryNotesRequest): Promise<GetOilDeliveryNotesResponse> {
    const client = new OilServiceClientImpl(this._rpc);
    return await client.getOilDeliveryNotes(request);
  }
}
